<ng-container *ngrxLet="action$ as action">
  <pt-loader-button
    type="stroked"
    [loading]="action.loading$ | async"
    [matBadge]="badge$ | async"
    [matBadgeHidden]="hideBadge$ | async"
    (click)="run(action)"
  >
    <div class="flex items-center gap-2">
      <span>{{ action.name }}</span>
      <mat-icon *ngIf="action.icon">{{ action.icon }}</mat-icon>
    </div>
  </pt-loader-button>
</ng-container>
